import { GenericResponse } from 'types/GenericResponse';
import { createAsyncAction } from 'utils/Redux';

const ns = 'RESET_WIDGET';

const asyncAction = createAsyncAction<GenericResponse>(ns);

const resetWidgetAction = {
  ...asyncAction,
};

export default resetWidgetAction;
